// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_os-0";